<template>
  <div ref="chartRef" style="width: 100vw; height: 100vh"></div>
  <div class="statistics">
    <div v-for="(level, index) in colorMap" :key="index">
      <div :style="{ backgroundColor: level[1] }" class="color-block"></div>
      <span>{{ levelLabels[index] }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
import mapJson from "../assets/geojson.json";

const chartRef = ref(null);

// 模拟每个社区的百分比数据
const mockPercentages = {
  0: 25,
  1: 30,
  2: 20,
  3: 25,
};

const levelLabels = ["100%", "98%以上", "96%以上", "96%以下"];

const colorMap = {
  0: ["rgba(6, 205, 142, 0.5)", "rgba(6, 205, 142, 1)"],
  1: ["rgba(29, 142, 236, 0.5)", "rgba(29, 142, 236, 1)"],
  2: ["rgba(208, 224, 8, 0.5)", "rgba(208, 224, 8, 1)"],
  3: ["rgba(219, 23, 19, 0.5)", "rgba(219, 23, 19, 1)"],
};

const resData = {
  status: [
    { name: "金山路社区", level: "0" },
    { name: "陈湾社区", level: "1" },
    { name: "滁阳社区", level: "2" },
    { name: "如意湖社区", level: "3" },
    { name: "营房社区", level: "0" },
    { name: "高庙社区", level: "2" },
    { name: "沿河社区", level: "3" },
    { name: "胜利社区", level: "1" },
  ],
};

function getData() {
  return mapJson;
}

echarts.registerMap("云南", getData());

let data = getData().features.map((item) => {
  return {
    name: item.properties.name,
  };
});

const regions = resData.status.map((element) => {
  const { name, level } = element;
  const color = colorMap[level];
  return {
    name,
    itemStyle: {
      normal: {
        areaColor: {
          type: "radial",
          x: 0.5,
          y: 0.5,
          r: 0.5,
          colorStops: [
            { offset: 0, color: color[0] },
            { offset: 1, color: color[1] },
          ],
          global: false,
        },
      },
      emphasis: {
        borderWidth: 3,
        borderColor: "#fff",
      },
    },
    label: {
      normal: {
        show: true,
        textStyle: { color: "#fff", fontSize: "120%" },
      },
    },
  };
});

let option = {
  backgroundColor: "#030528",
  geo: [
    {
      map: "云南",
      aspectScale: 1,
      zoom: 0.65,
      layoutCenter: ["50%", "50%"],
      layoutSize: "180%",
      show: true,
      roam: false,
      label: {
        emphasis: {
          show: false,
        },
      },
      itemStyle: {},
      regions: regions,
    },
    // 重影
    {
      type: "map",
      map: "云南",
      zlevel: -1,
      aspectScale: 1,
      zoom: 0.65,
      layoutCenter: ["50%", "51%"],
      layoutSize: "180%",
      roam: false,
      silent: true,
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: "rgba(58,149,253,0.8)",
          shadowColor: "rgba(172, 122, 255,0.5)",
          shadowOffsetY: 5,
          shadowBlur: 15,
          areaColor: "rgba(5,21,35,0.1)",
        },
      },
    },
    {
      type: "map",
      map: "云南",
      zlevel: -2,
      aspectScale: 1,
      zoom: 0.65,
      layoutCenter: ["50%", "52%"],
      layoutSize: "180%",
      roam: false,
      silent: true,
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: "rgba(58,149,253,0.6)",
          shadowColor: "rgba(65, 214, 255,0.6)",
          shadowOffsetY: 5,
          shadowBlur: 15,
          areaColor: "rgba(5,21,35,0.1)",
        },
      },
    },
    {
      type: "map",
      map: "云南",
      zlevel: -3,
      aspectScale: 1,
      zoom: 0.65,
      layoutCenter: ["50%", "53%"],
      layoutSize: "180%",
      roam: false,
      silent: true,
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: "rgba(58,149,253,0.4)",
          shadowColor: "rgba(29, 111, 165,1)",
          shadowOffsetY: 15,
          shadowBlur: 10,
          areaColor: "rgba(5,21,35,0.1)",
        },
      },
    },
    {
      type: "map",
      map: "云南",
      zlevel: -4,
      aspectScale: 1,
      zoom: 0.65,
      layoutCenter: ["50%", "54%"],
      layoutSize: "180%",
      roam: false,
      silent: true,
      itemStyle: {
        normal: {
          borderWidth: 5,
          borderColor: "rgba(5,9,57,0.8)",
          shadowColor: "rgba(29, 111, 165,0.8)",
          shadowOffsetY: 15,
          shadowBlur: 10,
          areaColor: "rgba(5,21,35,0.1)",
        },
      },
    },
  ],
  series: [
    {
      name: "云南",
      type: "map",
      map: "云南",
      aspectScale: 1,
      zoom: 0.65,
      showLegendSymbol: true,
      label: {
        normal: {
          show: false,
          textStyle: { color: "#fff", fontSize: "120%" },
        },
        emphasis: {
          show: false,
        },
      },
      itemStyle: {
        normal: {
          areaColor: {
            type: "linear",
            x: 1200,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 1,
                color: "rgba(0,0,0,0)",
              },
            ],
            global: false,
          },
          borderColor: "#fff",
          borderWidth: 0.2,
        },
        emphasis: {
          show: false,
          color: "#fff",
          areaColor: "rgba(0,0,0,0)",
        },
      },
      layoutCenter: ["50%", "50%"],
      layoutSize: "180%",
      markPoint: {
        symbol: "none",
      },
      data: data,
    },
  ],
};

// 获取对应等级的百分比
const getPercentage = (level) => {
  return mockPercentages[level.toString()] || 0;
};

let chart;
onMounted(() => {
  chart = echarts.init(chartRef.value);
  chart.setOption(option);

//   // 点击事件处理
//   chart.on("click", "geo", (params) => {
//     const selectedName = params.name;
//     const newRegions = regions.map((region) => {
//       if (region.name === selectedName) {
//         return {
//           ...region,
//           itemStyle: {
//             ...region.itemStyle,
//             normal: {
//               ...region.itemStyle.normal,
//               borderWidth: 3,
//               borderColor: "#fff",
//             },
//           },
//         };
//       }
//       return {
//         ...region,
//         itemStyle: {
//           ...region.itemStyle,
//           normal: {
//             ...region.itemStyle.normal,
//             borderWidth: 0,
//           },
//         },
//       };
//     });

//     chart.setOption({
//       geo: {
//         regions: newRegions,
//       },
//     });
//   });
});
</script>

<style scoped>
.statistics {
  position: absolute;
  left: 20px;
  bottom: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 5px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start
}

.color-block {
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-right: 5px;
  vertical-align: middle;
}
</style>
